<header app-header class="l-header" [resizeMenu]="menuResize" [mobile]="windowSize.w <= 1024"
  [mobileIcon]="enableMobileIcon" [ngClass]="{ 'l-header--scrolled': enableMenuScroll }"></header>

<!-- TODO -->
<!-- <app-gave-permission></app-gave-permission> -->

<main class="l-appMain" [ngClass]="{ 'l-appMain--md': scrollDistance > 70 || enableMenuScroll }">
  <router-outlet></router-outlet>
</main>

<app-footer *ngIf="!hideFooter"></app-footer>
